import { CORE_VALUES } from './Form/formConstants';

interface OneOnOneCardProps {
  index: number;
  name: string;
  dateOfIncident: string;
  position: string;
  department: string;
  supervisor: string;
  dateOfHire?: string;
  policyViolation: string;
  descriptionOfOneOnOne: string;
  coreValues: string[];
  meetingGoal: string;
  privateNotes?: string;
  createdAt?: string;
}

const OneOnOneCard = ({
  index,
  name,
  dateOfIncident,
  position,
  department,
  supervisor,
  dateOfHire,
  policyViolation,
  descriptionOfOneOnOne,
  coreValues,
  meetingGoal,
  privateNotes,
  createdAt,
}: OneOnOneCardProps) => {
  const getCoreValueLabels = (values: string[]) => {
    if (!values || values.length === 0) return 'N/A';
    return values
      .map((valueId) => {
        const coreValue = CORE_VALUES.find((cv) => cv.id === valueId);
        return coreValue ? coreValue.label : valueId;
      })
      .join(', ');
  };

  return (
    <div className="mb-4 p-3 border rounded" style={{ backgroundColor: '#f8f9fa' }}>
      <h6 className="text-primary mb-3">
        <i className="fas fa-user mr-2" />
        {index + 1}. {name}
      </h6>

      <div className="row">
        <div className="col-md-6">
          <p>
            <strong>Date of Incident:</strong> {dateOfIncident}
          </p>
          <p>
            <strong>Position:</strong> {position}
          </p>
          <p>
            <strong>Department:</strong> {department}
          </p>
          <p>
            <strong>Supervisor:</strong> {supervisor}
          </p>
          {dateOfHire && (
            <p>
              <strong>Date of Hire:</strong> {dateOfHire}
            </p>
          )}
        </div>
        <div className="col-md-6">
          <p>
            <strong>Policy Violation:</strong> {policyViolation}
          </p>
          <p>
            <strong>Core Values:</strong> {getCoreValueLabels(coreValues)}
          </p>
          {createdAt && (
            <p>
              <strong>Created At:</strong> {createdAt}
            </p>
          )}
        </div>
      </div>

      <div className="mt-3">
        <p>
          <strong>Description of One On One:</strong>
        </p>
        <p className="text-muted" style={{ whiteSpace: 'pre-wrap' }}>
          {descriptionOfOneOnOne}
        </p>
      </div>

      <div className="mt-3">
        <p>
          <strong>Meeting Goal:</strong>
        </p>
        <p className="text-muted" style={{ whiteSpace: 'pre-wrap' }}>
          {meetingGoal}
        </p>
      </div>

      {privateNotes && (
        <div className="mt-3">
          <p className="text-warning">
            <i className="fas fa-lock mr-2" />
            <strong>Private Notes:</strong>
          </p>
          <p className="text-muted" style={{ whiteSpace: 'pre-wrap' }}>
            {privateNotes}
          </p>
          <small className="text-muted">Only visible to Director and Upper Management</small>
        </div>
      )}
    </div>
  );
};

export default OneOnOneCard;
